import React from 'react';
import Locale from '../domain/Locale';
import ProductDomain from '../domain/Product';
import Color from '../domain/Color';
import ProductCard from './ProductCard';
import ProductDetails from './ProductDetails';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  product: ProductDomain,
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  showDetails: t.Bool
})
export default class Product extends React.Component {

  getDetails() {
    if (!this.props.showDetails){
      return null;
    }

    return <ProductDetails locale={this.props.locale}  product={this.props.product} themeBtnColor={this.props.themeBtnColor} />;
  }

  render() {
    return (
      <div className="product-display">
        <ProductCard locale={this.props.locale}  product={this.props.product}  themeBgColor={this.props.themeBgColor} themeBgFontColor={this.props.themeBgFontColor} />
        { this.getDetails() }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Product.js
 **/